import React from "react";

const PageNotFound = () => {
    return <h1>This page does not exist.</h1>;
  };
  
  export default PageNotFound;